import { render, staticRenderFns } from "./Multiplo.vue?vue&type=template&id=989d6a68&scoped=true"
import script from "./Multiplo.vue?vue&type=script&lang=js"
export * from "./Multiplo.vue?vue&type=script&lang=js"
import style0 from "./Multiplo.vue?vue&type=style&index=0&id=989d6a68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989d6a68",
  null
  
)

export default component.exports